import { render, staticRenderFns } from "./events.vue?vue&type=template&id=1eff2207&scoped=true&"
import script from "./events.vue?vue&type=script&lang=js&"
export * from "./events.vue?vue&type=script&lang=js&"
import style0 from "./events.vue?vue&type=style&index=0&id=1eff2207&prod&scoped=true&lang=css&"
import style1 from "./events.vue?vue&type=style&index=1&id=1eff2207&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff2207",
  null
  
)

export default component.exports